import { useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useAuth() {
  const queryClient = useQueryClient()

  const { data: session, isLoading } = useQuery({
    queryKey: ['auth', 'session'],
    queryFn: () => supabase.auth.getSession().then(({ data: { session } }) => session),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, newSession) => {
      queryClient.setQueryData(['auth', 'session'], newSession)
    })
    return () => subscription.unsubscribe()
  }, [queryClient])

  const signOut = async () => {
    await supabase.auth.signOut()
  }

  return {
    session: session ?? null,
    user: session?.user ?? null,
    isLoading,
    signOut,
  }
}
